import React, {useEffect, useState} from "react";
import queryString from 'query-string';
import history from "../../history";
import muellifSecimListesi from "../../services/muellifSecimListesi";
import basvuruMuellifGuncelle from "../../services/basvuruMuellifGuncelle";
import {Card,Row,Col,message,Spin,Form,Input,Select,Button,Tooltip as TooltipAnd} from 'antd';
const { Option } = Select;
const parsed = queryString.parse(history.location.search);
const formItemStyle = {
    marginLeft : 10
}
const formLayout = {
    labelCol : {
        span : 4
    },
    wrapperCol : {
        span : 8
    }
}
const MuellifSecimForm = () => {
    const [spining, setSpining] = useState(true);
    const [form] = Form.useForm();
    const [secimListesi , setSecimListesi] = useState([]);
    const [muellifData, setMuellifData ] = useState([]);
    const loadForm = async () => {
        let basvuruMuellifs = [];
        await muellifSecimListesi(parsed).then(resp => {
            if(resp.data.success){
                setSecimListesi(resp.data.result);
                resp.data.result.map(key=>{
                    if( key.coklu_secilebilir_mi == 0){
                        let items = [];
                        items["altSurecTipiId"] = key.muellifYetkiAltSurecTipiId;
                        if(key.muellifSecimKontrol.muellifBuroId != null){
                            items["muellifId"] = key.muellifSecimKontrol.muellifBuroId[0];
                        }
                        basvuruMuellifs.push(items);
                    }                    
                })
            }else{
                message.error(resp.data.message);
            }
             
        });
        await setMuellifData(basvuruMuellifs);
 
        setSpining(false);
    }
    useEffect(() => {
        loadForm();
    }, []);
    const onChange =(val,altSurec)=> {
        muellifData.map(key => {
            if(key["altSurecTipiId"] == altSurec){
                key["muellifId"] = val;
            }           
        });

        setMuellifData(muellifData);
    }
    const onFinish = (values) =>{
        setSpining(true);
        let data = [];
        let filterModel= {};
       
    
        Object.keys(values).forEach(function(key) {           
            let filterModel= {};
          
            if(Array.isArray(values[key])){
                values[key].map(el => {
                    filterModel= {};
                    filterModel.altSurecTipiId = secimListesi[0].altSurecTipiId == null ? key : secimListesi[0].altSurecTipiId;
                    filterModel.ebMuellifBuroId = el;
                    filterModel.muellifYetkiAltSurecTipiId = key;
                    filterModel.basvuruMuellifYetkiId = parsed.muellifYetkiId;
                    filterModel.basvuruAnaId = parsed.parentBasvuruId;
                    filterModel.cokluSecilebilirMi = 1;

                    data.push(filterModel);
                });
                if(values[key].length == 0){
                    filterModel= {};
                    filterModel.altSurecTipiId = secimListesi[0].altSurecTipiId == null ? key : secimListesi[0].altSurecTipiId;
                    filterModel.ebMuellifBuroId = null;
                    filterModel.muellifYetkiAltSurecTipiId = key;
                    filterModel.basvuruMuellifYetkiId = parsed.muellifYetkiId;
                    filterModel.basvuruAnaId = parsed.parentBasvuruId;
                    filterModel.cokluSecilebilirMi = 1;

                    data.push(filterModel);
                }
            }        
        });
     
      
    
        muellifData.map(key=>{
                filterModel= {};
                filterModel.altSurecTipiId = secimListesi[0].altSurecTipiId == null ? key.altSurecTipiId : secimListesi[0].altSurecTipiId;
                filterModel.ebMuellifBuroId = key.muellifId;
                filterModel.muellifYetkiAltSurecTipiId =  key.altSurecTipiId;
                filterModel.basvuruMuellifYetkiId = parsed.muellifYetkiId;
                filterModel.basvuruAnaId = parsed.parentBasvuruId;
                filterModel.cokluSecilebilirMi = 0;
                data.push(filterModel);
        });
        
        if(data.length == 0){
            secimListesi.map(key=>{
                if(key.muellifSecimKontrol.muellifBuroId != null){
                    key.muellifSecimKontrol.muellifBuroId.map(val=>{
                        filterModel= {};
                        filterModel.altSurecTipiId = key.altSurecTipiId == null ? key.muellifYetkiAltSurecTipiId : key.altSurecTipiId;
                        filterModel.ebMuellifBuroId = val;
                        filterModel.muellifYetkiAltSurecTipiId = key.muellifYetkiAltSurecTipiId;
                        filterModel.basvuruMuellifYetkiId = parsed.muellifYetkiId;
                        filterModel.basvuruAnaId = parsed.parentBasvuruId;
                        filterModel.cokluSecilebilirMi = 1;
                        data.push(filterModel);
                    })
                }            
            })
        }
        if(data.length > 0){
            basvuruMuellifGuncelle(data).then(res => { 
                if(res.data.success){
                    message.success('İşlem başarı ile tamamlandı.');
                    setSpining(false);
                    window.parent.location.reload(); 
                }else{
                    message.error(res.data.message);
                    setSpining(false);
                }})
            .catch(ex => {
                setSpining(false);
            });
        }else{
            message.error("Müellif Seçimi Yapınız.");
            setSpining(false);
        }

        
         
    }
   

    return(
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>
           <Card bodyStyle={{padding: "10",fontWeight:"bold"}}>
            Başvuru Müellifleri Belirleme Formu
           </Card> 
           <Form form={form}  {...formLayout} onFinish={onFinish}>
                {secimListesi.map(key => ( 
                    <Form.Item key={key.muellifYetkiAltSurecTipiId}  label={key.muellifYetkiAltSurecTipiAdi} name={key.muellifYetkiAltSurecTipiId} style={formItemStyle}  labelAlign="left">
                       {key.coklu_secilebilir_mi ?
                        <Select
                            showSearch
                            mode="multiple"
                            defaultValue=
                            {key.muellifSecimKontrol.muellifBuroId != null ? key.muellifSecimKontrol.muellifBuroId : []}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            disabled={key.muellifSecimKontrol.isReadonly}>
                            {key.muellifBuroList && key.muellifBuroList.map(bt => <Option key={key.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                        </Select>
                     :  <Select
                            showSearch
                            defaultValue={key.muellifSecimKontrol.muellifBuroId}
                            key={key.muellifSecimKontrol.muellifBuroId}
                            onChange = {(el)=>onChange(el,key.muellifYetkiAltSurecTipiId)}
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            disabled={key.muellifSecimKontrol.isReadonly}
                            allowClear>
                            {key.muellifBuroList && key.muellifBuroList.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
                        </Select> 
                        }
                       
                    </Form.Item>
                ))}  
                <Row>
                    <Col span={12} style={{textAlign: 'right'}}>
                        <Button type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </Col>  
                </Row>  
            </Form> 
         </Spin>
    );
}

export default MuellifSecimForm;